// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-green[data-v-4137e794] {\n  border-color: #2DB782;\n}", ""]);
// Exports
module.exports = exports;
